module.exports = "<div class=\"font-12\" *ngIf=\"errorMessage !== null\">{{errorMessage}}</div>"